export const translations = {
  es: {
    nav: {
      villas: "Las villas",
      casita: "La Casita",
      loft: "Pura Brisa",
      story: "Historia",
      property: "La casa",
      experiences: "Momentos",
      gallery: "Galería",
      location: "Ubicación",
      book: "Reservar",
      contact: "Contacto",
      home: "Inicio",
    },
    villas_home: {
      hero_eyebrow: "Barra de Galindo · Tuxpan, Veracruz",
      hero_title_1: "Tres villas",
      hero_title_2: "frente al mar.",
      hero_sub: "Villas Pura Vida es un complejo íntimo de tres alojamientos a pie de playa en Barra de Galindo, Tuxpan: una casa amplia para hasta 14 personas, un loft para 6 y un mini loft para 6. Elige el que mejor se adapte a tu viaje.",
      hero_cta: "Conoce las villas",
      hero_badge: "10% menos vs Airbnb · reserva directo",
      villas_eyebrow: "Las villas",
      villas_title: "Elige dónde despertar frente al mar.",
      villas_sub: "Misma playa semivirgen, dos experiencias distintas. Una casa familiar amplia y un loft íntimo, ambos frente al mar.",
      compare_title: "Compara las villas",
      capacity: "Huéspedes",
      bedrooms: "Habitaciones",
      beds: "Camas",
      baths: "Baños",
      from: "desde",
      per_night: "por noche",
      airbnb_was: "Airbnb",
      view_property: "Ver propiedad",
      shared_title: "Lo que comparten las tres villas.",
      shared_sub: "Acceso directo a la misma playa semivirgen, vista al mar y al río, estacionamiento privado y la misma tranquilidad de Barra de Galindo.",
      story_eyebrow: "Villas Pura Vida",
      story_title: "Donde el tiempo transcurre más despacio.",
      story_p1: "A 3.5 horas de Ciudad de México, en una playa semivirgen del Golfo, tres alojamientos comparten el mismo espíritu: descanso auténtico, naturaleza y libertad.",
      story_p2: "Aquí no vienes a correr de actividad en actividad. Vienes a respirar profundo, a compartir tiempo de calidad y a dejar que el mar haga el resto.",
      legado_eyebrow: "Legado del abuelo",
      legado_title: "Antes de ser Villa, fue un sueño de infancia.",
      legado_p1: "El abuelo era un niño cuando aprendió a querer el mar. En casa no sobraba dinero para hoteles ni para una noche de playa, así que su padre decidió regalarles el día entero. Salían de madrugada —aún con las estrellas encima— los once en la misma marcha: él, su esposa y sus nueve hijos rumbo a Tuxpan.",
      legado_p2: "Pasaban la jornada completa sobre la arena: la comida envuelta de casa, los juegos sin reloj, el sol encima, las carreras entre las olas y la risa que no se agotaba. Al atardecer, antes de volver, se detenían en la cascada para quitarse la sal del cuerpo. Llegaban a casa cansados, descalzos, felices. No alcanzó para cenar fuera. No alcanzó para hotel. Alcanzó para toda una vida de recuerdos.",
      legado_p3: "Muchos años después —ya con sus propias familias, sus propias historias— tres de aquellos hermanos regresaron. Esta vez tomaron el camino más largo, el que lleva a Barra de Galindo. Encontraron la playa casi como la soñaron de niños: virgen, sin hoteles, con el mar entrando limpio y el silencio acomodado entre las palmeras.",
      legado_p4: "Compraron el terreno sin pensarlo dos veces. Y con el paso del tiempo, levantaron piedra sobre piedra, techo sobre techo, para que sus hijos y sus nietos pudieran quedarse a dormir frente al mar lo que ellos, de niños, no pudieron. Villas Pura Vida es eso: la noche de playa que el abuelo nunca tuvo, abierta ahora para tu familia.",
      legado_divider: "décadas después",
      legado_slogan: "Los lugares se heredan. Los recuerdos también.",
    },
    activities: {
      eyebrow: "Qué hacer",
      title: "Actividades en Barra de Galindo y Tuxpan.",
      sub: "Días sin prisas frente al mar. Aquí algunas de las experiencias que más disfrutan nuestros huéspedes.",
      items: [
        { t: "Caminar descalzo en el mar", d: "Kilómetros de arena semivirgen y olas tranquilas del Golfo." },
        { t: "Atardeceres del Golfo", d: "El cielo se tiñe de cálidos colores cada tarde frente a tu villa." },
        { t: "Carnita asada", d: "Asador disponible — prepara una carnita asada frente al mar con tu familia o amigos." },
        { t: "Fogata a la orilla del mar", d: "Por la noche, una fogata en la arena y el cielo lleno de estrellas." },
        { t: "Recorrer la playa", d: "Caminatas, paseos y largas conversaciones a lo largo de la costa." },
        { t: "Observación de cangrejos", d: "Por la noche, los cangrejos azules salen a caminar por la arena. Un espectáculo único del Golfo." },
        { t: "Conchitas y caracolas", d: "Recorre la playa al amanecer y descubre conchitas y caracolas que el mar trae cada noche." },
        { t: "Tortugas en temporada", d: "Si tienes suerte, podrás verlas anidar entre mayo y septiembre." },
        { t: "Jugar en la playa", d: "Volibol, frisbee, palas y todos los juegos posibles en la arena." },
        { t: "Recostarse en el mar", d: "Flotar en aguas tranquilas del Golfo y dejarse mecer por las olas." },
        { t: "Niños jugando", d: "Castillos de arena, baños, risas — un paraíso seguro para los más pequeños." },
        { t: "Disfrutar la Pura Vida", d: "Respirar profundo, soltar la prisa y dejar que el mar marque el ritmo del día." },
      ],
    },
    hero: {
      eyebrow: "Barra de Galindo · Tuxpan, Veracruz",
      sub: "Una casa frente al mar para familias, parejas y amigos que buscan reconectar con lo esencial.",
      cta_primary: "Reservar con 10% de descuento",
      cta_secondary: "Conocer la propiedad",
      badge: "10% menos vs Airbnb",
      back_to_villas: "Volver a las villas",
    },
    story: {
      eyebrow: "El espíritu",
    },
    property: {
      eyebrow: "El espacio",
      title_casita: "Una casa para hasta 14 huéspedes, frente al mar.",
      title_loft: "Un loft íntimo para hasta 6 huéspedes, frente al mar.",
      title_miniloft: "Un mini loft frente al mar, para hasta 6 huéspedes.",
      sub_casita: "Privada con pocas casas, ambiente tranquilo y seguro. Vista al mar y al río.",
      sub_loft: "Diseño abierto, climatizado y cómodo. Acceso directo a la playa y vista al mar y al río.",
      sub_miniloft: "Loft abierto tipo estudio con 2 matrimoniales y 2 individuales elevadas. Acceso directo a playa semivirgen, vista al mar y al río.",
      features: {
        bedrooms: { t: "3 habitaciones", d: "Climatizadas con aire acondicionado" },
        bedrooms_1: { t: "1 habitación", d: "Climatizada con aire acondicionado" },
        beds: { t: "8 camas", d: "Para familias y grupos grandes" },
        beds_4: { t: "4 camas", d: "2 matrimoniales + 2 individuales" },
        baths: { t: "2 baños completos", d: "Para mayor comodidad" },
        baths_1: { t: "1 baño completo", d: "Con agua caliente" },
        kitchen: { t: "Cocina equipada", d: "Prepara tus alimentos" },
        parking: { t: "Estacionamiento privado", d: "Dentro de la privada" },
        beach: { t: "Acceso directo a la playa", d: "Playa semivirgen" },
        view: { t: "Vista al mar y al río", d: "Desde el alba al atardecer" },
        living: { t: "Sala y comedor", d: "Para convivir sin prisas" },
        wifi: { t: "WiFi de fibra óptica", d: "Roku TV con streaming" },
      },
    },
    experiences: {
      eyebrow: "Momentos que recordarás",
      title: "Cada hora del día tiene algo especial.",
      items: [
        { t: "Amanecer con café frente al mar", d: "El sol pinta el cielo de tonos dorados mientras las olas acompañan tu primera taza." },
        { t: "Carnita asada al atardecer", d: "Comida al aire libre, conversación y el cielo tiñéndose de naranja sobre el Golfo." },
        { t: "Fogata bajo las estrellas", d: "Por la noche, el cielo se llena de estrellas y los sonidos de la naturaleza." },
        { t: "Cangrejos Azules", d: "Un espectáculo único de la costa del Golfo: los cangrejos azules salen a caminar por la arena al anochecer." },
        { t: "Conchas marinas y caracolas", d: "Camina al amanecer y descubre conchas y caracolas que el mar trae cada noche." },
        { t: "Caminar descalzo en la arena", d: "Kilómetros de playa semivirgen para perderse sin prisas." },
        { t: "Tarde de playa", d: "Sombrillas, lectura, juegos en la arena — las tardes pasan despacio frente al mar." },
        { t: "Diversión en la playa", d: "Volibol, frisbee y atardeceres compartidos en familia o entre amigos." },
      ],
    },
    gallery: {
      eyebrow: "Galería",
      title: "Un rincón donde el tiempo transcurre más despacio.",
    },
    location: {
      eyebrow: "Ubicación",
      title: "Playa Barra de Galindo, Tuxpan, Veracruz.",
      p1: "A 3.5 horas de Ciudad de México por autopista. El acceso final se realiza mediante un recorrido por la playa de aproximadamente 10 a 15 minutos.",
      p2: "Te recomendamos llegar de día y traer alimentos y bebidas para tu estancia, ya que los comercios más cercanos se encuentran a cierta distancia.",
      tip_title: "Importante",
      tip: "La zona es semivirgen — parte de su encanto. Ocasionalmente puede haber variaciones en internet o energía. Estaremos atentos para apoyarte.",
    },
    booking: {
      eyebrow: "Reservar",
      title: "Reserva directo — 10% menos que en Airbnb.",
      sub: "Selecciona fechas y huéspedes. Confirma con pago seguro o solicítanos por WhatsApp.",
      check_in: "Llegada",
      check_out: "Salida",
      guests: "Huéspedes",
      pick_dates: "Selecciona fechas",
      nights: "noche(s)",
      airbnb_total: "Total en Airbnb",
      web_total: "Total directo",
      you_save: "Ahorras",
      get_quote: "Calcular precio",
      continue: "Continuar a reservar",
      name: "Nombre completo",
      email: "Correo electrónico",
      phone: "Teléfono / WhatsApp",
      message: "Mensaje (opcional)",
      pay_online: "Pagar en línea (Stripe)",
      whatsapp: "Solicitar por WhatsApp",
      back: "Atrás",
      processing: "Procesando…",
      select_dates_first: "Selecciona fechas para ver el precio",
      fill_all: "Completa todos los campos para continuar",
      success_inquiry: "¡Gracias! Te contactaremos pronto.",
      error_generic: "Algo salió mal. Intenta de nuevo.",
      dates_taken: "Las fechas seleccionadas ya están reservadas. Prueba con otras.",
    },
    faq: {
      eyebrow: "Preguntas frecuentes",
      title: "Resolvemos tus dudas antes del viaje.",
      items: [
        { q: "¿Cómo llego a las villas?", a: "A 3.5 hrs de CDMX por autopista hasta Tuxpan. El tramo final son 10–15 min por la playa. Recomendamos llegar entre 2 y 5 pm con luz de día." },
        { q: "¿Cuál es la diferencia entre La Casita y Pura Brisa?", a: "La Casita es para hasta 14 huéspedes (3 hab, 8 camas, 2 baños), ideal para familias grandes o grupos. Pura Brisa es un loft más íntimo, hasta 6 huéspedes (1 hab, 4 camas, 1 baño), ideal para parejas y familias pequeñas." },
        { q: "¿Cuál es la política de cancelación?", a: "Cancelación flexible: contáctanos por WhatsApp para revisar tu caso particular." },
        { q: "¿Hay tienda cerca?", a: "Los comercios más cercanos están a cierta distancia. Sugerimos traer alimentos y bebidas para toda la estancia." },
        { q: "¿Aceptan mascotas?", a: "Sí, son bienvenidas en las tres villas. Por favor coméntanoslo al reservar." },
        { q: "¿Se hacen fiestas?", a: "No. Villas Pura Vida es para descanso, convivencia familiar y de amigos en un entorno tranquilo." },
      ],
    },
    footer: {
      tagline: "Los lugares se heredan. Los recuerdos también.",
      quick: "Enlaces",
      villas: "Las villas",
      contact: "Contacto",
      seo_title: "Hospedaje en Tuxpan, Veracruz a orilla del mar",
      seo: "Casa de playa, hotel, departamento y loft en Tuxpan Veracruz frente al mar. Villas Pura Vida está ubicada en Barra de Galindo, una de las playas semivírgenes más auténticas del Golfo de México.",
      rights: "Todos los derechos reservados.",
    },
    success: {
      title: "¡Reserva confirmada!",
      sub: "Gracias por reservar en Villas Pura Vida. Hemos enviado los detalles a tu correo.",
      home: "Volver al inicio",
      pending: "Verificando tu pago…",
      failed: "Tu pago no se completó.",
      retry: "Intentar de nuevo",
    },
  },
  en: {
    nav: {
      villas: "The villas",
      casita: "La Casita",
      loft: "Pura Brisa",
      story: "Story",
      property: "The house",
      experiences: "Moments",
      gallery: "Gallery",
      location: "Location",
      book: "Book",
      contact: "Contact",
      home: "Home",
    },
    villas_home: {
      hero_eyebrow: "Barra de Galindo · Tuxpan, Veracruz",
      hero_title_1: "Three villas",
      hero_title_2: "by the sea.",
      hero_sub: "Villas Pura Vida is an intimate complex of three beachfront properties in Barra de Galindo, Tuxpan: a large house for up to 14, a loft for 6 and a mini loft for 6. Choose the one that fits your trip.",
      hero_cta: "Discover the villas",
      hero_badge: "10% off vs Airbnb · book direct",
      villas_eyebrow: "The villas",
      villas_title: "Choose where to wake up by the sea.",
      villas_sub: "Same semi-virgin beach, two distinct experiences. A spacious family house and an intimate loft, both beachfront.",
      compare_title: "Compare the villas",
      capacity: "Guests",
      bedrooms: "Bedrooms",
      beds: "Beds",
      baths: "Baths",
      from: "from",
      per_night: "per night",
      airbnb_was: "Airbnb",
      view_property: "View property",
      shared_title: "What the three villas share.",
      shared_sub: "Direct access to the same semi-virgin beach, sea and river views, private parking, and the same calm of Barra de Galindo.",
      story_eyebrow: "Villas Pura Vida",
      story_title: "Where time slows down.",
      story_p1: "3.5 hours from Mexico City, on a semi-virgin Gulf beach, three stays share the same spirit: authentic rest, nature and freedom.",
      story_p2: "You don't rush from activity to activity here. You breathe deeply, share quality time, and let the sea do the rest.",
      legado_eyebrow: "Grandfather's legacy",
      legado_title: "Before it was a Villa, it was a childhood dream.",
      legado_p1: "Grandfather was a boy when he learned to love the sea. There was no money at home for hotels or a night by the beach, so his father decided to give them the whole day instead. They would leave before dawn —stars still above them— all eleven on the same ride: him, his wife, and their nine children heading to Tuxpan.",
      legado_p2: "They would spend the full day on the sand: food wrapped from home, games without a clock, the sun overhead, races between the waves, and laughter that never ran out. At dusk, before heading back, they would stop at the waterfall to wash the salt off. They arrived home tired, barefoot, happy. There was no money for dinner out. No money for a hotel. There was, however, enough for a lifetime of memories.",
      legado_p3: "Many years later —with their own families, their own stories— three of those brothers came back. This time they took the longer road, the one that leads to Barra de Galindo. They found the beach almost as they had dreamt it as kids: untouched, hotel-free, with the sea rolling in clean and silence settled between the palms.",
      legado_p4: "They bought the land without thinking twice. And over time, they raised stone upon stone, roof upon roof, so that their children and grandchildren could spend the night by the sea that they, as boys, never could. Villas Pura Vida is just that: the beach night Grandfather never had, open now to your family.",
      legado_divider: "decades later",
      legado_slogan: "Places are inherited. So are the memories.",
    },
    activities: {
      eyebrow: "What to do",
      title: "Activities in Barra de Galindo and Tuxpan.",
      sub: "Unhurried days by the sea. A few of the experiences our guests enjoy most.",
      items: [
        { t: "Barefoot in the sea", d: "Miles of semi-virgin sand and the calm Gulf waves." },
        { t: "Gulf sunsets", d: "The sky paints itself in warm tones every afternoon outside your villa." },
        { t: "Carne asada", d: "Grill available — cook a carne asada by the sea with family or friends." },
        { t: "Bonfire by the shore", d: "By night, a fire on the sand and a sky full of stars." },
        { t: "Walk the coast", d: "Long walks, rides and conversations along the shore." },
        { t: "Watching crabs", d: "By night the blue crabs walk the sand. A unique Gulf coast sight." },
        { t: "Shells and conches", d: "Walk at dawn and find shells and conches the sea brings every night." },
        { t: "Sea turtles in season", d: "If you're lucky, watch them nest between May and September." },
        { t: "Play on the beach", d: "Volleyball, frisbee, paddles and every sand game you can think of." },
        { t: "Float in the sea", d: "Drift in the calm Gulf waters and let the waves rock you." },
        { t: "Kids playing", d: "Sand castles, swimming, laughter — a safe paradise for little ones." },
        { t: "Enjoy the Pura Vida", d: "Breathe deeply, let go of the rush, and let the sea set the day's rhythm." },
      ],
    },
    hero: {
      eyebrow: "Barra de Galindo · Tuxpan, Veracruz",
      sub: "A beachfront house for families, couples and friends who want to reconnect with the essential.",
      cta_primary: "Book with 10% discount",
      cta_secondary: "See the property",
      badge: "10% off vs Airbnb",
      back_to_villas: "Back to the villas",
    },
    story: { eyebrow: "The spirit" },
    property: {
      eyebrow: "The space",
      title_casita: "A home for up to 14 guests, right by the sea.",
      title_loft: "An intimate loft for up to 6 guests, right by the sea.",
      title_miniloft: "A mini loft by the sea, for up to 6 guests.",
      sub_casita: "Private community with few houses. Calm and safe. Sea and river views.",
      sub_loft: "Open, air-conditioned, comfortable design. Direct beach access and sea + river views.",
      sub_miniloft: "Open studio-style loft with 2 queen beds and 2 elevated singles. Direct access to a semi-virgin beach, with sea and river views.",
      features: {
        bedrooms: { t: "3 bedrooms", d: "Air-conditioned" },
        bedrooms_1: { t: "1 bedroom", d: "Air-conditioned" },
        beds: { t: "8 beds", d: "For families and large groups" },
        beds_4: { t: "4 beds", d: "2 queens + 2 singles" },
        baths: { t: "2 full bathrooms", d: "Comfortable for everyone" },
        baths_1: { t: "1 full bathroom", d: "Hot water" },
        kitchen: { t: "Equipped kitchen", d: "Cook your own meals" },
        parking: { t: "Private parking", d: "Within the community" },
        beach: { t: "Direct beach access", d: "Semi-virgin beach" },
        view: { t: "Sea and river view", d: "From dawn to dusk" },
        living: { t: "Living & dining", d: "Gather without rush" },
        wifi: { t: "Fiber WiFi", d: "Roku TV streaming" },
      },
    },
    experiences: {
      eyebrow: "Moments to remember",
      title: "Every hour of the day has something special.",
      items: [
        { t: "Sunrise coffee by the sea", d: "Golden tones fill the sky as the waves greet your first cup." },
        { t: "Sunset carne asada", d: "Outdoor meal, conversation, and the sky turning orange over the Gulf." },
        { t: "Bonfire under the stars", d: "By night, the sky fills with stars and nature's sounds." },
        { t: "Blue crabs", d: "A unique sight of the Gulf coast: blue crabs walking the sand at dusk." },
        { t: "Seashells and conches", d: "Walk at dawn and find shells and conches the sea brings every night." },
        { t: "Barefoot on the sand", d: "Miles of semi-virgin beach to wander unhurried." },
        { t: "Beach afternoons", d: "Umbrellas, reading, games in the sand — afternoons go slow by the sea." },
        { t: "Fun on the beach", d: "Volleyball, frisbee and shared sunsets with family or friends." },
      ],
    },
    gallery: { eyebrow: "Gallery", title: "A corner where time slows down." },
    location: {
      eyebrow: "Location",
      title: "Playa Barra de Galindo, Tuxpan, Veracruz.",
      p1: "3.5 hours from Mexico City by highway. The final access is a 10–15 min drive along the beach.",
      p2: "We recommend arriving by daylight and bringing food and drinks for your stay, as the nearest shops are some distance away.",
      tip_title: "Good to know",
      tip: "This is a semi-virgin area — part of its charm. Internet or power may occasionally fluctuate. We're always available to help.",
    },
    booking: {
      eyebrow: "Book",
      title: "Book direct — 10% less than Airbnb.",
      sub: "Pick your dates and guests. Confirm with secure payment or request via WhatsApp.",
      check_in: "Check-in",
      check_out: "Check-out",
      guests: "Guests",
      pick_dates: "Pick your dates",
      nights: "night(s)",
      airbnb_total: "Airbnb total",
      web_total: "Direct total",
      you_save: "You save",
      get_quote: "Calculate price",
      continue: "Continue to book",
      name: "Full name",
      email: "Email",
      phone: "Phone / WhatsApp",
      message: "Message (optional)",
      pay_online: "Pay online (Stripe)",
      whatsapp: "Request via WhatsApp",
      back: "Back",
      processing: "Processing…",
      select_dates_first: "Pick dates to see the price",
      fill_all: "Fill all fields to continue",
      success_inquiry: "Thanks! We'll reach out soon.",
      error_generic: "Something went wrong. Try again.",
      dates_taken: "Selected dates are already booked. Try other dates.",
    },
    faq: {
      eyebrow: "FAQ",
      title: "Common questions before your trip.",
      items: [
        { q: "How do I get there?", a: "3.5 hrs from CDMX by highway to Tuxpan. Final 10–15 min along the beach. Arrive between 2–5pm by daylight." },
        { q: "Difference between La Casita and Pura Brisa?", a: "La Casita hosts up to 14 (3 bed, 8 beds, 2 baths) — for large families/groups. Pura Brisa is an intimate loft, up to 6 (1 bed, 4 beds, 1 bath) — for couples and small families." },
        { q: "Cancellation policy?", a: "Flexible — reach out on WhatsApp to review your case." },
        { q: "Stores nearby?", a: "Nearest shops are some distance away. Bring food and drinks for your stay." },
        { q: "Pets allowed?", a: "Yes, pets welcome in both villas. Please let us know when booking." },
        { q: "Parties?", a: "No. Villas Pura Vida is for rest and family/friend gatherings in a calm environment." },
      ],
    },
    footer: {
      tagline: "Places are inherited. So are the memories.",
      quick: "Links",
      villas: "The villas",
      contact: "Contact",
      seo_title: "Beachfront lodging in Tuxpan, Veracruz",
      seo: "Beach house, hotel, apartment and loft in Tuxpan Veracruz by the sea. Villas Pura Vida is located in Barra de Galindo, one of the most authentic semi-virgin beaches of the Gulf of Mexico.",
      rights: "All rights reserved.",
    },
    success: {
      title: "Booking confirmed!",
      sub: "Thanks for booking at Villas Pura Vida. We've sent the details to your email.",
      home: "Back home",
      pending: "Verifying your payment…",
      failed: "Your payment didn't go through.",
      retry: "Try again",
    },
  },
};
